"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSafeState = exports.useExternal = exports.useUnmountedRef = exports.useLockFn = exports.useWebSocket = exports.useTrackedEffect = exports.useCountDown = exports.useFavicon = exports.useReactive = exports.useTimeout = exports.useNetwork = exports.useTitle = exports.useWhyDidYouUpdate = exports.useInterval = exports.useSetState = exports.useCookieState = exports.useFusionTable = exports.useHistoryTravel = exports.useEventTarget = exports.useTextSelection = exports.useUpdate = exports.useCounter = exports.useMount = exports.useDrop = exports.useDrag = exports.useCreation = exports.useMap = exports.usePersistFn = exports.useSet = exports.useUnmount = exports.useAntdTable = exports.UseRequestProvider = exports.useRequest = exports.useHover = exports.useEventListener = exports.useKeyPress = exports.useInViewport = exports.useFullscreen = exports.useClickAway = exports.useScroll = exports.useMouse = exports.usePrevious = exports.useDebounceEffect = exports.useDebounceFn = exports.useDebounce = exports.useThrottleEffect = exports.useThrottleFn = exports.useThrottle = exports.useSelections = exports.useDocumentVisibility = exports.useToggle = exports.useBoolean = exports.useUpdateLayoutEffect = exports.useUpdateEffect = exports.configResponsive = exports.useSize = exports.useSessionStorageState = exports.useLocalStorageState = exports.useEventEmitter = exports.useResponsive = exports.useVirtualList = exports.useDynamicList = exports.useControllableValue = exports.useControlledValue = void 0;

var use_request_1 = __importStar(require("@ahooksjs/use-request"));

exports.useRequest = use_request_1["default"];
Object.defineProperty(exports, "UseRequestProvider", {
  enumerable: true,
  get: function get() {
    return use_request_1.UseRequestProvider;
  }
});

var useControllableValue_1 = __importDefault(require("./useControllableValue"));

exports.useControllableValue = useControllableValue_1["default"];

var useDynamicList_1 = __importDefault(require("./useDynamicList"));

exports.useDynamicList = useDynamicList_1["default"];

var useEventEmitter_1 = __importDefault(require("./useEventEmitter"));

exports.useEventEmitter = useEventEmitter_1["default"];

var useVirtualList_1 = __importDefault(require("./useVirtualList"));

exports.useVirtualList = useVirtualList_1["default"];

var useResponsive_1 = require("./useResponsive");

Object.defineProperty(exports, "configResponsive", {
  enumerable: true,
  get: function get() {
    return useResponsive_1.configResponsive;
  }
});
Object.defineProperty(exports, "useResponsive", {
  enumerable: true,
  get: function get() {
    return useResponsive_1.useResponsive;
  }
});

var useSize_1 = __importDefault(require("./useSize"));

exports.useSize = useSize_1["default"];

var useLocalStorageState_1 = __importDefault(require("./useLocalStorageState"));

exports.useLocalStorageState = useLocalStorageState_1["default"];

var useSessionStorageState_1 = __importDefault(require("./useSessionStorageState"));

exports.useSessionStorageState = useSessionStorageState_1["default"];

var useUpdateEffect_1 = __importDefault(require("./useUpdateEffect"));

exports.useUpdateEffect = useUpdateEffect_1["default"];

var useUpdateLayoutEffect_1 = __importDefault(require("./useUpdateLayoutEffect"));

exports.useUpdateLayoutEffect = useUpdateLayoutEffect_1["default"];

var useBoolean_1 = __importDefault(require("./useBoolean"));

exports.useBoolean = useBoolean_1["default"];

var useToggle_1 = __importDefault(require("./useToggle"));

exports.useToggle = useToggle_1["default"];

var useDocumentVisibility_1 = __importDefault(require("./useDocumentVisibility"));

exports.useDocumentVisibility = useDocumentVisibility_1["default"];

var useSelections_1 = __importDefault(require("./useSelections"));

exports.useSelections = useSelections_1["default"];

var useThrottle_1 = __importDefault(require("./useThrottle"));

exports.useThrottle = useThrottle_1["default"];

var useThrottleFn_1 = __importDefault(require("./useThrottleFn"));

exports.useThrottleFn = useThrottleFn_1["default"];

var useThrottleEffect_1 = __importDefault(require("./useThrottleEffect"));

exports.useThrottleEffect = useThrottleEffect_1["default"];

var useDebounce_1 = __importDefault(require("./useDebounce"));

exports.useDebounce = useDebounce_1["default"];

var useDebounceFn_1 = __importDefault(require("./useDebounceFn"));

exports.useDebounceFn = useDebounceFn_1["default"];

var usePrevious_1 = __importDefault(require("./usePrevious"));

exports.usePrevious = usePrevious_1["default"];

var useMouse_1 = __importDefault(require("./useMouse"));

exports.useMouse = useMouse_1["default"];

var useScroll_1 = __importDefault(require("./useScroll"));

exports.useScroll = useScroll_1["default"];

var useClickAway_1 = __importDefault(require("./useClickAway"));

exports.useClickAway = useClickAway_1["default"];

var useFullscreen_1 = __importDefault(require("./useFullscreen"));

exports.useFullscreen = useFullscreen_1["default"];

var useInViewport_1 = __importDefault(require("./useInViewport"));

exports.useInViewport = useInViewport_1["default"];

var useKeyPress_1 = __importDefault(require("./useKeyPress"));

exports.useKeyPress = useKeyPress_1["default"];

var useEventListener_1 = __importDefault(require("./useEventListener"));

exports.useEventListener = useEventListener_1["default"];

var useHover_1 = __importDefault(require("./useHover"));

exports.useHover = useHover_1["default"];

var useUnmount_1 = __importDefault(require("./useUnmount"));

exports.useUnmount = useUnmount_1["default"];

var useAntdTable_1 = __importDefault(require("./useAntdTable"));

exports.useAntdTable = useAntdTable_1["default"];

var useFusionTable_1 = __importDefault(require("./useFusionTable"));

exports.useFusionTable = useFusionTable_1["default"];

var useSet_1 = __importDefault(require("./useSet"));

exports.useSet = useSet_1["default"];

var usePersistFn_1 = __importDefault(require("./usePersistFn"));

exports.usePersistFn = usePersistFn_1["default"];

var useMap_1 = __importDefault(require("./useMap"));

exports.useMap = useMap_1["default"];

var useCreation_1 = __importDefault(require("./useCreation"));

exports.useCreation = useCreation_1["default"];

var useDrop_1 = __importDefault(require("./useDrop"));

exports.useDrop = useDrop_1["default"];

var useDrag_1 = __importDefault(require("./useDrag"));

exports.useDrag = useDrag_1["default"];

var useMount_1 = __importDefault(require("./useMount"));

exports.useMount = useMount_1["default"];

var useTextSelection_1 = __importDefault(require("./useTextSelection"));

exports.useTextSelection = useTextSelection_1["default"];

var useCounter_1 = __importDefault(require("./useCounter"));

exports.useCounter = useCounter_1["default"];

var useUpdate_1 = __importDefault(require("./useUpdate"));

exports.useUpdate = useUpdate_1["default"];

var useEventTarget_1 = __importDefault(require("./useEventTarget"));

exports.useEventTarget = useEventTarget_1["default"];

var useHistoryTravel_1 = __importDefault(require("./useHistoryTravel"));

exports.useHistoryTravel = useHistoryTravel_1["default"];

var useDebounceEffect_1 = __importDefault(require("./useDebounceEffect"));

exports.useDebounceEffect = useDebounceEffect_1["default"];

var useCookieState_1 = __importDefault(require("./useCookieState"));

exports.useCookieState = useCookieState_1["default"];

var useSetState_1 = __importDefault(require("./useSetState"));

exports.useSetState = useSetState_1["default"];

var useInterval_1 = __importDefault(require("./useInterval"));

exports.useInterval = useInterval_1["default"];

var useWhyDidYouUpdate_1 = __importDefault(require("./useWhyDidYouUpdate"));

exports.useWhyDidYouUpdate = useWhyDidYouUpdate_1["default"];

var useTitle_1 = __importDefault(require("./useTitle"));

exports.useTitle = useTitle_1["default"];

var useNetwork_1 = __importDefault(require("./useNetwork"));

exports.useNetwork = useNetwork_1["default"];

var useTimeout_1 = __importDefault(require("./useTimeout"));

exports.useTimeout = useTimeout_1["default"];

var useReactive_1 = __importDefault(require("./useReactive"));

exports.useReactive = useReactive_1["default"];

var useFavicon_1 = __importDefault(require("./useFavicon"));

exports.useFavicon = useFavicon_1["default"];

var useCountDown_1 = __importDefault(require("./useCountDown"));

exports.useCountDown = useCountDown_1["default"];

var useWebSocket_1 = __importDefault(require("./useWebSocket"));

exports.useWebSocket = useWebSocket_1["default"];

var useLockFn_1 = __importDefault(require("./useLockFn"));

exports.useLockFn = useLockFn_1["default"];

var useTrackedEffect_1 = __importDefault(require("./useTrackedEffect"));

exports.useTrackedEffect = useTrackedEffect_1["default"];

var useUnmountedRef_1 = __importDefault(require("./useUnmountedRef"));

exports.useUnmountedRef = useUnmountedRef_1["default"];

var useExternal_1 = __importDefault(require("./useExternal"));

exports.useExternal = useExternal_1["default"];

var useSafeState_1 = __importDefault(require("./useSafeState"));

exports.useSafeState = useSafeState_1["default"];

var useControlledValue = function useControlledValue() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  console.warn('useControlledValue is deprecated and will be removed in the next major version. Please use useControllableValue instead.');
  return useControllableValue_1["default"].apply(void 0, __spread(args));
};

exports.useControlledValue = useControlledValue;